import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-wf-week",
  "use": "icon-soc-wf-week-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-wf-week\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<rect x=\"192\" y=\"256\" width=\"640\" height=\"576\" rx=\"40\" /><path d=\"M192 256h640v128H192z\" /><path d=\"M320 192h64v128h-64zM640 192h64v128h-64z\" /><path d=\"M256 544h96v96H256zM400 544h96v96H400zM544 544h96v96H544zM688 544h80v96H688z\" fill=\"#fff\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-wf-week.svg
// module id = sw9B
// module chunks = 491